import site from '../site.json';

// Native apply switch per board (FEAT-APPLY). sites/<site>/site.json → "apply":
//   { "mode": "off" | "test" | "on", "api": "<submitApplication URL>", "turnstileSiteKey": "<public key>" }
// "test" shows the modal only with ?applytest=1 in the URL (the owner's test bed, refugee first).
// Anything missing or off keeps today's email Apply.
export function nativeApply(search = typeof window !== 'undefined' ? window.location.search : '') {
  const cfg = site.apply || {};
  if (!cfg.api || !cfg.turnstileSiteKey) return null;
  if (cfg.mode === 'on') return cfg;
  if (cfg.mode === 'test' && new URLSearchParams(search).get('applytest') === '1') return cfg;
  return null;
}
